// Generated by purs version 0.11.7
"use strict";
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Traversable.Accum/index.js
// module id = 142
// module chunks = 0